export const MONITORING_RISK_INPUT_DOLLAR_FIELDS = [
  {
    key: 'currentCash',
    label: 'Current Cash',
    sourceKey: 'currentCashSource',
    commentKey: 'currentCashComment',
  },
  {
    key: 'netBurn',
    label: 'Net Burn',
    sourceKey: 'netBurnSource',
    commentKey: 'netBurnComment',
  },
  {
    key: 'monthlyOpex',
    label: 'Monthly Opex',
    sourceKey: 'monthlyOpexSource',
    commentKey: 'monthlyOpexComment',
  },
  {
    key: 'debt',
    label: 'Debt',
    sourceKey: 'debtSource',
    commentKey: 'debtComment',
  },
  {
    key: 'totalAssets',
    label: 'Total Asset',
    sourceKey: 'totalAssetsSource',
    commentKey: 'totalAssetsComment',
  },
  {
    key: 'totalLiabilities',
    label: 'Total Liabilities',
    sourceKey: 'totalLiabilitiesSource',
    commentKey: 'totalLiabilitiesComment',
  },
  {
    key: 'safe',
    label: 'SAFE',
    sourceKey: 'safeSource',
    commentKey: 'safeComment',
  },
  {
    key: 'predictedRunoff12Months',
    label: 'Predicted Runoff',
    sourceKey: 'predictedRunoffSource',
    commentKey: 'predictedRunoffComment',
  },
];

export const MONITORING_RISK_INPUT_SCORE_FIELDS = [
  {
    key: 'stressTestingScore',
    label: 'Stress Testing',
    commentKey: 'stressTestingComment',
  },
  {
    key: 'investorsScore',
    label: 'Investors',
    commentKey: 'investorsComment',
  },
  {
    key: 'managementScore',
    label: 'Management',
    commentKey: 'managementComment',
  },
];

export function formatMonitoringRiskInputDisplay(value) {
  if (value == null || !Number.isFinite(Number(value))) {
    return '';
  }
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatMonitoringRiskInputScoreDisplay(value) {
  if (value == null || value === '') {
    return '';
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return '';
  }
  return String(Math.round(n));
}
